import React from "react";
import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import { PostLogin } from "../component/Header";
import AutomationHistoryContent from "../component/AssignmentRules/AutomationHistory/AutomationHistoryContent";
import { useRequireRBAC } from "../component/shared/useRequireRBAC";
import { PERMISSION_KEY } from "../types/Rbac/permission";

function AutomationHistory() {
  const { t } = useTranslation();
  const pageName = t("nav.automation.historyPage");

  useRequireRBAC([PERMISSION_KEY.automationViewDetails]);

  return (
    <div className={`post-login`}>
      <PostLogin selectedItem={"Automation"} />
      <Helmet title={t("nav.common.title", { page: pageName })} />
      <AutomationHistoryContent />
    </div>
  );
}

export default AutomationHistory;
